/**
 * Portal ICAVI - Serviço de domínio: Relatórios de Lanches
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const lanchesServiceMethods = {
    async getRelatorioLanches(params = {}, dataInicio = null, dataFim = null) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_inicio && params.data_fim) {
                queryParams.append('data_inicio', params.data_inicio);
                queryParams.append('data_fim', params.data_fim);
            }
            else if (dataInicio && dataFim) {
                queryParams.append('data_inicio', dataInicio);
                queryParams.append('data_fim', dataFim);
            }
            else if (params.data) {
                queryParams.append('data', params.data);
            }
            if (params.nome)
                queryParams.append('nome', params.nome);
            if (params.empresa)
                queryParams.append('empresa', params.empresa);
            if (params.tipo_refeicao)
                queryParams.append('tipo_refeicao', params.tipo_refeicao);
            const url = `/api/relatorio-lanches${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('🍽️ Erro ao buscar relatório de lanches:', error);
            throw error;
        }
    },
    async alterarStatusLanche(lancheId) {
        try {
            const response = await api.put(`/api/recepcao/lanches/${lancheId}`, {
                lanche: 'Não',
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao alterar status do lanche:', error);
            if (axios.isAxiosError(error) && error.response?.data?.status === 'erro') {
                return error.response.data;
            }
            throw error;
        }
    },
    async restaurarLanche(lancheId) {
        try {
            const response = await api.put(`/api/recepcao/lanches/${lancheId}/restaurar`, {});
            return response.data;
        }
        catch (error) {
            console.error('Erro ao restaurar status do lanche:', error);
            if (axios.isAxiosError(error) && error.response?.data?.status === 'erro') {
                return error.response.data;
            }
            throw error;
        }
    },
    async marcarExportadosRelatorioLanches(ids, origem) {
        const response = await api.post('/api/recepcao/relatorio-lanches/marcar-exportados', { ids, origem });
        return response.data;
    },
    async cadastrarLancheRecepcao(dados) {
        try {
            const response = await api.post('/api/recepcao/lanches', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao cadastrar lanche na recepcao:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async getRelatorioLanchesTerceiras(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data)
                queryParams.append('data', params.data);
            if (params.nome)
                queryParams.append('nome', params.nome);
            if (params.empresa)
                queryParams.append('empresa', params.empresa);
            if (params.tipo_refeicao)
                queryParams.append('tipo_refeicao', params.tipo_refeicao);
            const url = `/api/relatorio-lanches-terceiras${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar relatório de lanches terceiras:', error);
            throw error;
        }
    },
    async getRelatorioLanchesExcluidos(params = {}, dataInicio = null, dataFim = null) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_inicio && params.data_fim) {
                queryParams.append('data_inicio', params.data_inicio);
                queryParams.append('data_fim', params.data_fim);
            }
            else if (dataInicio && dataFim) {
                queryParams.append('data_inicio', dataInicio);
                queryParams.append('data_fim', dataFim);
            }
            else if (params.data) {
                queryParams.append('data', params.data);
            }
            if (params.nome)
                queryParams.append('nome', params.nome);
            if (params.empresa)
                queryParams.append('empresa', params.empresa);
            if (params.tipo_refeicao)
                queryParams.append('tipo_refeicao', params.tipo_refeicao);
            const url = `/api/recepcao/relatorio-lanches/excluidos${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar relatório de lanches excluídos:', error);
            throw error;
        }
    },
};
